<div class="inner-content">
  <ion-toolbar color="primary">
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">{{modalTitle}}</ion-title>
  </ion-toolbar>

  @if (!!modal_subtitle) {
    <div class="ion-padding" style="text-align: center">
      <ion-label class="fs-pt-16"><b>{{modal_subtitle}}</b></ion-label>
    </div>
  }

  <br>

    @if (modalMessage && modalMessage !== '') {
      <div class="ion-padding" style="text-align: center">
        <ion-label class="fs-pt-14">{{modalMessage}}</ion-label>
      </div>
    }

    @if (second_modal_message && second_modal_message !== '') {
      <div class="ion-padding" style="text-align: center">
        <ion-label class="fs-pt-14">{{second_modal_message}}</ion-label>
      </div>
    }

    <div class="ion-padding-horizontal">
      @for (field of getFields(); track field) {
        @if (!!field) {
          <ion-item>
            <ion-input [formControl]="getFormCtrl(field)"
            label="{{field | titlecase}}'" labelPlacement="floating"></ion-input>
            @if ((field === 'password') && getFormCtrl(field).touched && getFormCtrl(field).hasError('pattern')) {
              <ion-note color="danger" class="ion-text-justify"
                slot="error">
                {{errorMessagePasswordPattern}}
              </ion-note>
            }
            @if ((field === 'e-mail') && getFormCtrl(field).touched && getFormCtrl(field).hasError('pattern')) {
              <ion-note color="danger" class="ion-text-justify"
                slot="error">
                {{errorMessageEmailPattern}}
              </ion-note>
            }
          </ion-item>
        }
      }
    </div>

    <!-- <ng-container *ngIf="areTermsAndConditionsVisible">
    <app-terms-and-conditions></app-terms-and-conditions>
  </ng-container>-->

  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size-sm="12" size-xl="6" size-md="8">
        @if (isConfirmButtonVisible) {
          <ion-button class="ion-margin-top ion-text-uppercase"
            [disabled]="formGroup.invalid"
            color="primary" (click)="confirmFunction(formGroup)" fill="solid"
          expand="block">{{confirmButtonText | uppercase}}</ion-button>
        }
        @if (isCancelButtonVisible) {
          <ion-button class="ion-margin-top ion-text-uppercase"
            color="danger" (click)="cancel()" fill="solid"
          expand="block">{{cancelButtonText | uppercase}}</ion-button>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
